import React, { useMemo } from 'react';

const SummaryList = ({ items, title, testId }) => {
  const unique = useMemo(() => [...new Set(items)], [items]);
  return <><h3>{title}</h3><ul data-testid={testId}>{unique.map(text => <li key={text}>{text}</li>)}</ul></>;
};

export const ReviewSummary = ({ review, copy }) => <>
  <h3>{copy.summary}</h3><p data-testid="review-summary">{review.summary}</p>
  <SummaryList items={review.details} title={copy.details} testId="review-details" />
  <SummaryList items={review.unanswered_questions} title={copy.questions} testId="review-questions" />
  <h3>{copy.next}</h3><p data-testid="review-next-action">{review.next_action}</p>
</>;